import PropTypes from 'prop-types';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

// project imports
import AuthWrapper from './AuthWrapper';
import mwLogo from '../../assets/images/mw-logo.png';
import { sendPasswordEmail } from '../../utils/api';

export default function AuthForgot({ isDemo = false }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('secondary');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setMessageType('secondary');

    try {
      const data = await sendPasswordEmail({ email });

      if (data.status === 1) {
        setMessage('Password reset link has been sent to your email.');
        setMessageType('success.main');
      } else {
        setMessage(data.message || 'Something went wrong.');
        setMessageType('error.main');
      }
    } catch (err) {
      setMessage(err?.response?.data?.message || 'Server error. Please try again later.');
      setMessageType('error.main');
    }

    setLoading(false);
  };

  return (
    <AuthWrapper>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Stack spacing={3} alignItems="center">
            {/* Logo + Heading */}
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="h4" fontWeight="bold">
                Forgot Password
              </Typography>
              <img src={mwLogo} alt="MW Logo" style={{ width: 35, height: 35 }} />
            </Stack>

            {/* Form */}
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <Stack spacing={2}>
                <TextField
                  label="Email Address"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  required
                />

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </Button>

                {message && (
                  <Typography variant="body2" color={messageType} textAlign="center">
                    {message}
                  </Typography>
                )}

                <Typography
                  component={RouterLink}
                  to="/login"
                  variant="body2"
                  sx={{ textDecoration: 'none', mt: 1 }}
                  color="primary"
                  textAlign="center"
                >
                  Back to Login
                </Typography>
              </Stack>
            </form>
          </Stack>
        </Grid>
      </Grid>
    </AuthWrapper>
  );
}

AuthForgot.propTypes = {
  isDemo: PropTypes.bool
};
